import React from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { clearSession } from "../../components/Utils";
import { useDisplayMode } from "../context/DisplayModeContext";
import { isPwaAnonymousRoute } from "../layouts/pwaConfig";
import { isPwaSignedIn, languagePickerPath, pwaEntryPath, readPwaSession } from "./pwaSession";

const PwaAccessGuard = () => {
  const { standalone } = useDisplayMode();
  const location = useLocation();
  const { pathname } = location;
  if (!standalone) return <Outlet />;

  const { valid, denied } = readPwaSession();
  // localStorage is shared with the browser, so a farmer session can arrive here; drop it on every route.
  if (denied) clearSession();
  if (isPwaAnonymousRoute(pathname)) return <Outlet />;
  if (!valid || denied) return <Navigate replace to={languagePickerPath()} state={{ from: location }} />;
  return <Outlet />;
};

// Installed app has no public landing: `/` redirects on, and login is reached only through the language picker.
export const StandaloneEntry = ({ children }) => {
  const { state } = useLocation();
  if (!children) return <Navigate replace to={pwaEntryPath()} />;
  if (isPwaSignedIn()) return <Navigate replace to={`${window.contextPath}/home`} />;
  if (state?.languagePicked !== true) {
    return <Navigate replace to={languagePickerPath()} state={state?.from ? { from: state.from } : undefined} />;
  }
  return children;
};

StandaloneEntry.propTypes = {
  children: PropTypes.node,
};

export default PwaAccessGuard;
